import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Star, Bookmark, ArrowLeft, ShoppingBag, Loader2, Check } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { startCheckout } from "@/lib/checkout";
import { Loader, PassionBadge, PrimaryButton, GhostButton, money } from "@/components/ui-bits";
import { toast } from "sonner";

export default function ListingDetail() {
  const { id } = useParams();
  const [l, setL] = useState(null);
  const [saving, setSaving] = useState(false);
  const load = () => api.get(`/marketplace/${id}`).then((r) => setL(r.data));
  useEffect(() => { setL(null); load(); }, [id]);

  const save = async () => {
    setSaving(true);
    try { const { data } = await api.post(`/marketplace/${id}/save`); setL((x) => ({ ...x, saved: data.saved })); toast(data.saved ? "Saved to favorites" : "Removed from saved"); }
    catch { toast.error("Action failed"); } finally { setSaving(false); }
  };

  if (!l) return <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8"><Loader /></div>;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
      <Link to="/marketplace" className="inline-flex items-center gap-1.5 text-sm text-[#55708F] hover:text-[#FF6B00] mb-5" data-testid="back-to-market"><ArrowLeft className="h-4 w-4" />Marketplace</Link>
      <div className="grid md:grid-cols-2 gap-8">
        <div className="rounded-3xl overflow-hidden aspect-square"><img src={fileUrl(l.image)} alt={l.title} className="h-full w-full object-cover" /></div>
        <div>
          <div className="flex items-center gap-2 mb-3"><PassionBadge slug={l.passion} /><span className="text-xs px-2.5 py-1 rounded-full bg-[#071126]/6 text-[#071126]/60 font-semibold">{l.category}</span></div>
          <h1 className="text-3xl font-extrabold tracking-tight text-[#071126]">{l.title}</h1>
          {l.rating > 0 && <div className="flex items-center gap-1 mt-2 text-sm text-[#55708F]"><Star className="h-4 w-4 fill-[#FFC94A] text-[#FFC94A]" />{l.rating} · {l.review_count} reviews</div>}
          <p className="text-3xl font-extrabold text-[#FF6B00] mt-4">{money(l.price, l.currency)}</p>
          <p className="text-[#071126]/70 leading-relaxed mt-4 whitespace-pre-wrap">{l.description}</p>

          <Link to={`/u/${l.seller?.id}`} className="flex items-center gap-3 mt-6 pa-card p-4 pa-card-hover" data-testid="listing-seller">
            <img src={fileUrl(l.seller?.avatar)} alt="" className="h-11 w-11 rounded-full object-cover" />
            <div><p className="text-xs text-[#55708F]">Sold by</p><p className="font-semibold text-[#071126]">{l.seller?.name}</p></div>
          </Link>

          <div className="flex gap-3 mt-6">
            <PrimaryButton className="flex-1" onClick={() => l.price > 0 ? startCheckout("listing", l.id) : toast("This item is free")} data-testid="buy-listing-btn"><ShoppingBag className="h-4 w-4" />{l.listing_type === "service" ? "Request" : "Buy now"}</PrimaryButton>
            <GhostButton onClick={save} disabled={saving} data-testid="save-listing-btn">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Bookmark className={`h-4 w-4 ${l.saved ? "fill-[#FF6B00] text-[#FF6B00]" : ""}`} />}{l.saved ? "Saved" : "Save"}</GhostButton>
          </div>
          <p className="text-xs text-center text-[#55708F] mt-3">Secure checkout by Stripe. Use test card 4242 4242 4242 4242 with any future expiry &amp; CVC.</p>
        </div>
      </div>
    </div>
  );
}
